import { Injectable } from '@angular/core';
import { VesselLandingItem } from '@app/domain/entities/vessel-landing.entity';
import {
  VesselLandingListParams,
  VesselNameSuggestionParams,
} from '@app/domain/models/vessel-landing.model';
import { VesselLandingRepository } from '@app/domain/repositories/vessel-landing.repository';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { map, Observable } from 'rxjs';
import { VesselLandingService } from '../api-clients/vessel-landing.service';
import { VesselLandingMapper } from '../mappers/vessel-landing.mapper';

@Injectable()
export class VesselLandingRepositoryImpl implements VesselLandingRepository {
  private readonly _mapper = new VesselLandingMapper();

  constructor(private readonly _vesselLandingService: VesselLandingService) {}

  getList(
    params: VesselLandingListParams
  ): Observable<PaginatedResponse<VesselLandingItem>> {
    return this._vesselLandingService
      .getList(params)
      .pipe(map(dto => this._mapper.listToDomain(dto)));
  }

  getNameSuggestions(
    params: VesselNameSuggestionParams
  ): Observable<PaginatedResponse<string>> {
    return this._vesselLandingService.getNameSuggestions(params);
  }

  getClientCodes(): Observable<string[]> {
    return this._vesselLandingService
      .getClientCodes()
      .pipe(map(dto => this._mapper.clientCodesToDomain(dto)));
  }

  getVesselSchemes(): Observable<string[]> {
    return this._vesselLandingService
      .getVesselSchemes()
      .pipe(map(dto => this._mapper.schemesToDomain(dto)));
  }
}
